import { MuiDialogActions, MuiDialogContent, MuiDialogTitle, MuiDialog } from './MuiDialog';
import { MuiBreadcrumbs } from './MuiBreadcrumbs';
import { MuiButton } from './MuiButton';
import { MuiDrawer } from './MuiDrawer';
import { MuiTooltip } from './MuiTooltip';
import { MuiTab, MuiTabs } from './MuiTabs';
import { MuiTable, MuiTableCell, MuiTableRow } from './MuiTable';
import { MuiDateCalendar } from './MuiDateCalendar';
import { MuiAccordion, MuiAccordionSummary, MuiAccordionDetails } from './MuiAccordion';

const MuiAlert = {
  defaultProps: {
    variant: 'outlined',
  },
  styleOverrides: {
    root: {
      marginBottom: '8px',
    },
  },
};

const MuiFormField = {
  defaultProps: {
    size: 'small',
  },
  styleOverrides: {
    root: {
      marginBottom: '16px',
    },
  },
};

const MuiTextField = {
  defaultProps: {
    size: 'small',
  },
  styleOverrides: {
    root: {
      marginBottom: '16px',
    },
  },
};

const MuiSelect = {
  defaultProps: {
    size: 'small',
  },
  styleOverrides: {
    root: {
      marginBottom: '16px',
    },
  },
};

export const components = {
  MuiTooltip,
  MuiButton,
  MuiAccordion,
  MuiAccordionSummary,
  MuiAccordionDetails,
  MuiTabs,
  MuiTab,
  MuiDrawer,
  MuiTable,
  MuiTableRow,
  MuiTableCell,
  MuiAlert,
  MuiFormField,
  MuiTextField,
  MuiSelect,
  MuiDateCalendar,
  MuiBreadcrumbs,
  MuiDialogContent,
  MuiDialogActions,
  MuiDialogTitle,
  MuiDialog,
};